import { createClient } from 'next-sanity'

export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || ''
export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET || 'production'
export const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-10-01'

// Whether Sanity is actually configured for this build/environment.
export const sanityConfigured = projectId.length > 0

// When the Sanity env vars aren't set (e.g. a fresh Cloudflare Pages project),
// `createClient` would throw "Configuration must contain 'projectId'" at IMPORT
// time — before any try/catch around a fetch can help — and crash the whole
// `next build` while collecting pages (e.g. /sitemap.xml). Fall back to a
// syntactically-valid placeholder so the client constructs; the fetches then
// reject and every caller (sitemap, generateStaticParams, CmsPage) degrades to
// its hardcoded fallback. Set NEXT_PUBLIC_SANITY_PROJECT_ID to use real content.
const safeProjectId = projectId || 'placeholder'

export const sanity = createClient({
  projectId: safeProjectId,
  dataset,
  apiVersion,
  useCdn: process.env.NODE_ENV === 'production',
  perspective: 'published',
  stega: false,
})

export const sanityWrite = createClient({
  projectId: safeProjectId,
  dataset,
  apiVersion,
  token: process.env.SANITY_API_WRITE_TOKEN,
  useCdn: false,
})
